// frontend/src/features/content/NewContent.js
import NewContentForm from "./NewContentForm"; // ✅ NewContentForm इम्पोर्ट करें
import useTitle from "../../hooks/useTitle";
import { Container } from "react-bootstrap";

const NewContent = () => {
    useTitle('Nirakar Satguru: Add New Content');

    // फिलहाल, NewContent में कोई जटिल प्री-फेचिंग लॉजिक नहीं है।
    // यह बस NewContentForm को रेंडर करता है।
    // भविष्य में, यदि NewContentForm को किसी विशिष्ट प्रारंभिक डेटा की आवश्यकता होती है,
    // तो आप उसे यहां फेच कर सकते हैं और NewContentForm को एक प्रोप के रूप में पास कर सकते हैं।

    const content = (
        <Container className="my-4">
            <NewContentForm />
        </Container>
    );

    return content;
};

export default NewContent;